import { errorHandler } from "./error.service";
import { http, URL } from "./http.service";

export const createShiprocketOrder = async (businessId, orderData) => {
  try {
    const resp = await http.post(
      `${URL}/logistics/${businessId}/shiprocket/create-order`,
      orderData
    );
    return resp;
  } catch (error) {
    console.error("Error creating Shiprocket order:", error);
    errorHandler(error);
    throw error;
  }
};

export const checkShiprocketServiceability = async (businessId, params) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const resp = await http.get(
      `${URL}/logistics/${businessId}/shiprocket/serviceability?${queryString}`
    );
    return resp;
  } catch (error) {
    console.error("Error checking serviceability:", error);
    errorHandler(error);
    throw error;
  }
};

export const assignShiprocketAwb = async (businessId, awbData) => {
  try {
    const resp = await http.post(
      `${URL}/logistics/${businessId}/shiprocket/assign-awb`,
      awbData
    );
    return resp;
  } catch (error) {
    console.error("Error assigning AWB:", error);
    errorHandler(error);
    throw error;
  }
};

export const getShiprocketStatus = async (businessId, orderId) => {
  try {
    const resp = await http.get(
      `${URL}/logistics/${businessId}/shiprocket/status/${orderId}`
    );
    return resp;
  } catch (error) {
    console.error("Error getting Shiprocket status:", error);
    errorHandler(error);
    throw error;
  }
};

export const generateShiprocketLabel = async (businessId, labelData) => {
  try {
    const resp = await http.post(
      `${URL}/logistics/${businessId}/shiprocket/generate-label`,
      labelData
    );
    return resp;
  } catch (error) {
    console.error("Error generating label:", error);
    errorHandler(error);
    throw error;
  }
};

export const scheduleShiprocketPickup = async (businessId, pickupData) => {
  try {
    const resp = await http.post(
      `${URL}/logistics/${businessId}/shiprocket/schedule-pickup`,
      pickupData
    );
    return resp;
  } catch (error) {
    console.error("Error scheduling pickup:", error);
    errorHandler(error);
    throw error;
  }
};

export const trackShiprocketShipment = async (businessId, awbCode) => {
  try {
    const resp = await http.get(
      `${URL}/logistics/${businessId}/shiprocket/track?awb_code=${awbCode}`
    );
    return resp;
  } catch (error) {
    console.error("Error tracking shipment:", error);
    errorHandler(error);
    throw error;
  }
};

export const generateShiprocketManifest = async (businessId, manifestData) => {
  try {
    const resp = await http.post(
      `${URL}/logistics/${businessId}/shiprocket/generate-manifest`,
      manifestData
    );
    return resp;
  } catch (error) {
    console.error("Error generating manifest:", error);
    errorHandler(error);
    throw error;
  }
};
